import { clsx } from 'clsx';
import { Fragment } from 'react';

import { LinkWithBasename } from '@jane/bloom/components/linkWithBasename';

import styles from './breadcrumbs.module.css';

export type Breadcrumb = {
  label: string;
  to?: string;
};

export interface BreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
  className?: string;
  visibleOnViewports?: 'desktop' | 'all';
}

export function Breadcrumbs({
  breadcrumbs,
  className,
  visibleOnViewports = 'all',
}: BreadcrumbsProps) {
  return (
    <div
      className={clsx(
        styles['breadcrumbs'],
        {
          [styles['breadcrumbs--desktop-only']]:
            visibleOnViewports === 'desktop',
        },
        className
      )}
    >
      {breadcrumbs.map(({ label, to }, index) => (
        <Fragment key={label}>
          {to ? (
            <LinkWithBasename to={to} variant="reefer-underline">
              {label}
            </LinkWithBasename>
          ) : (
            <div className={styles['breadcrumbText']}>{label}</div>
          )}
          {index !== breadcrumbs.length - 1 ? <span> /</span> : null}
        </Fragment>
      ))}
    </div>
  );
}
